import React, { useMemo, useState } from "react";
import GradeAccordion from "./GradeAccordion";
import { BaseDropdown, BaseInput, Ptag } from "components/core";
import { colors } from "theme";
import "./styles.css";

const FORMIK_AMBULANCE = [
  "ambulance_limit",
  "ambulance_min",
  "ambulance_max",
  "ambulance_remarks",
]

const FORMIK_OPD = [
  "opd_limit",
  "opd_min",
  "opd_max",
  "opd_remarks",
]

const FORMIK_CONG_EXTERNAL = [
  "congenital_external_limit",
  "congenital_external_min",
  "congenital_external_max",
  "congenital_external_remarks",
]

const FORMIK_CONG_INTERNAL = [
  "congenital_internal_limit",
  "congenital_internal_min",
  "congenital_internal_max",
  "congenital_internal_remarks",
]

const FORMIK_AYUSH_TREATMENT = [
  "ayush_treatment_limit",
  "ayush_treatment_min",
  "ayush_treatment_max",
  "ayush_treatment_remarks",
]

const FORMIK_CRITICAL = [
  "critical_illness_limit",
  "critical_illness_min",
  "critical_illness_max",
  "critical_illness_remarks",
]

const FORMIK_DENTAL = [
  "dental_limit",
  "dental_min",
  "dental_max",
  "dental_remarks",
]

const FORMIK_HEALTH = [
  "health_checkup_limit",
  "health_checkup_min",
  "health_checkup_max",
  "health_checkup_remarks",
]

const GradeDynamic = ({
  title,
  formikProps,
  attribute,
  formikKey,
  toggleHandler,
}) => {
  let selectedDetails = localStorage.getItem("eb_selected_values");
  if (selectedDetails) {
    selectedDetails = JSON.parse(selectedDetails);
  }

  const isFlex = useMemo(() => {
    return selectedDetails?.flex;
  }, [selectedDetails]);

  const doesValueExist = useMemo(() => {
    const values = formikProps.values;
    switch (title) {
      case "Ambulance Charges":
        return FORMIK_AMBULANCE.some(key => values[key]);
      case "OPD Charges":
        return FORMIK_OPD.some(key => values[key]);
      case "Congenital External Disease Coverage":
        return FORMIK_CONG_EXTERNAL.some(key => values[key]);
      case "Congenital Internal Disease Coverage":
        return FORMIK_CONG_INTERNAL.some(key => values[key]);
      case "AYUSH Treatment":
        return FORMIK_AYUSH_TREATMENT.some(key => values[key]);
      case "Critical Illness Coverages":
        return FORMIK_CRITICAL.some(key => values[key]);
      case "Dental Coverage":
        return FORMIK_DENTAL.some(key => values[key]);
      case "Health Checkup Coverage":
        return FORMIK_HEALTH.some(key => values[key]);
      default:
        return false;
    }
  }, [formikProps]);

  const initalToggleStatus = useMemo(() => {
    let status = false;
    if (!attribute?.toggle) {
      status = true;
    }
    if (doesValueExist) status = true;
    return status;
  }, [formikProps, attribute, formikKey]);

  const [toggleStatus, setToggleStatus] = useState(initalToggleStatus);

  const showRange = useMemo(() => {
    return attribute?.selectable_values.length > 0;
  }, [attribute]);

  const options = useMemo(() => {
    return attribute?.selectable_values.map((val) => ({
      label: val,
      value: val,
    }));
  }, [attribute]);

  const interstitialToggler = (bool) => {
    setToggleStatus(bool);
    if(!bool) {
      switch (title) {
        case "Ambulance Charges":
          FORMIK_AMBULANCE.forEach(key => {
            formikProps.setFieldValue(key, "", true);
          });
          break;
        case "OPD Charges":
          FORMIK_OPD.forEach(key => {
            formikProps.setFieldValue(key, "", true);
          });
          break;
        case "Congenital External Disease Coverage":
          FORMIK_CONG_EXTERNAL.forEach(key => {
            formikProps.setFieldValue(key, "", true);
          });
          break;
        case "Congenital Internal Disease Coverage":
          FORMIK_CONG_INTERNAL.forEach(key => {
            formikProps.setFieldValue(key, "", true);
          });
          break;
        case "AYUSH Treatment":
          FORMIK_AYUSH_TREATMENT.forEach(key => {
            formikProps.setFieldValue(key, "", true);
          });
          break;
        case "Critical Illness Coverages":
          FORMIK_CRITICAL.forEach(key => {
            formikProps.setFieldValue(key, "", true);
          });
          break;
        case "Dental Coverage":
          FORMIK_DENTAL.forEach(key => {
            formikProps.setFieldValue(key, "", true);
          });
          break;
        case "Health Checkup Coverage":
          FORMIK_HEALTH.forEach(key => {
            formikProps.setFieldValue(key, "", true);
          });
          break;
      }
    }
    toggleHandler &&
      toggleHandler(bool, attribute?.attribute_data?.attribute_name);
  };

  return attribute ? (
    <GradeAccordion
      title={title}
      canSelect={toggleStatus}
      showSwitch={attribute?.toggle}
      setToggleStatus={interstitialToggler}
      expanded={toggleStatus}
    >
      <section>
        <div className="sum-insured-container">
          {showRange ? (
            <BaseDropdown
              fontSize="16"
              staticLabel="Limit"
              disabled={!toggleStatus}
              options={options}
              formikProps={{
                ...formikProps,
                name: `${formikKey}_limit`,
              }}
            />
          ) : (
            <BaseInput
              staticLabel="Limit"
              fontSize="16px !important"
              type="text"
              disabled={!toggleStatus}
              formikProps={{ ...formikProps, name: `${formikKey}_limit` }}
            />
          )}
          {showRange && isFlex && (
            <div>
              <Ptag
                color={colors.primaryColor}
                fontSize="14px"
                marginBottom="16px"
              >
                Range
              </Ptag>
              <div className="sum-insured-container">
                <BaseInput
                  label="Min"
                  fontSize="16px !important"
                  type="text"
                  disabled={!toggleStatus}
                  formatToIndianNumbering
                  formikProps={{ ...formikProps, name: `${formikKey}_min` }}
                />
                <BaseInput
                  label="Max"
                  fontSize="16px !important"
                  type="text"
                  disabled={!toggleStatus}
                  formatToIndianNumbering
                  formikProps={{ ...formikProps, name: `${formikKey}_max` }}
                />
              </div>
            </div>
          )}
        </div>
        <div
          style={{
            marginTop: "2rem",
          }}
        >
          <BaseInput
            staticLabel="Remarks (optional)"
            fontSize="16px !important"
            type="text"
            disabled={!toggleStatus}
            formikProps={{ ...formikProps, name: `${formikKey}_remarks` }}
          />
        </div>
      </section>
    </GradeAccordion>
  ) : null;
};

export default GradeDynamic;
